import React, { useEffect } from 'react'
import { shape, func } from 'prop-types'

import useSimulationPermission from '@hooks/useSimulationPermission'
import useContact from '@hooks/useContact'
import useInternationalization from '@hooks/useInternationalization'
import useMagicLink from '@hooks/useMagicLink'

import calculatePrice from '@client/services/proposal'

import Footer from '@components/NewFooter'

import * as Sections from './sections'

function BrokerCommercialOffer({ actions }) {
  const { hasMagicLink } = useMagicLink()
  if (!hasMagicLink) {
    useSimulationPermission()
  }

  const { setFunnelStage, setBrokerFunnelStage } = actions
  const { contact } = useContact()
  const { country } = useInternationalization()

  useEffect(() => {
    async function getOffer() {
      const { data } = await calculatePrice(contact.employeesNumber, country)

      const discount = data.valueWithoutDiscount - data.value

      const offer = {
        discount,
        proposalValue: data.value,
        proposalValueWithoutDiscount: data.valueWithoutDiscount,
        couponCode: data.coupon.code,
        id: contact.id,
        funnelStage: 'broker_proposal',
        dependentsValue: data.dependentsValue,
        commercialOfferLink: `${window.location.protocol}//${window.location.host}/digital/${country}/simulate/commercial-offer?magic-link=${contact.magicLink}`,
        commercialOfferLinkBrokers: `${window.location.protocol}//${window.location.host}/digital/${country}/broker/simulate/commercial-offer?magic-link=${contact.magicLink}`,
      }

      await setFunnelStage(offer)
      if (contact.brokerInfo) {
        await setBrokerFunnelStage(contact.brokerInfo.id, 'broker_proposal')
      }
    }
    getOffer()
  }, [contact.employeesNumber])

  return (
    <>
      <Sections.Appbar contact={contact} actions={{ setBrokerFunnelStage }} />
      <Sections.Main contact={contact} actions={actions} />
      <Footer company="Gympass B.V." />
    </>
  )
}
BrokerCommercialOffer.propTypes = {
  actions: shape({
    setFunnelStage: func,
    setBrokerFunnelStage: func,
  }).isRequired,
}
export default BrokerCommercialOffer
